const logotext = "Sumit";
const meta = {
    title: "Sumit Verma",
    description: "Full Stack Developer(MERN)",
};

const introdata = {
    title: "I’m Sumit Verma",
    animated: {
        first: "MERN Stack Developer",
        second: "Welcome to my Portfolio",
        // third: "I develop mobile apps",
    },
    description: "Hello! I'm a dedicated MERN stack developer who loves crafting innovative web solutions. With expertise in MongoDB, Express.js, React, and Node.js, I focus on creating efficient and scalable applications. Dive into my projects to see the breadth of my work and the creativity I bring to each challenge.",
    your_img_url: require("./my.jpeg"),
};

const dataabout = {
    title: "My Intro",
    aboutme: "I am a MERN stack Developer & 2022 BTech passout from Rajasthan Technical University specialization Electrical with honour.I have experience in MERN stack less than a year .I have knowledge of Mongodb ,Nodejs, reactjs, RestAPI , C ,Java, php ,express js, pug , OOPs, JDBC, SQL, HTML, CSS, javascript , bootstrap, material-ui , Git, GItLab / GitHub, Dreamweaver, intellj , Adobe Photoshop.I am from Kota Rajasthan India",
};
const worktimeline = [{
        jobtitle: "MERN Stack Deveoper",
        where: "CodeArrest Pvt Ltd Associated with Mechlin Technology",
        duration: "worked (June 2023 to Oct 2023)",
    },
    {
        jobtitle: "MERN Stack Developer(Training)",
        where: "SRV IT Solutions",
        duration: "5 Months",
    },
   
    // {
    //     jobtitle: "Designer of week",
    //     where: "ALquds",
    //     date: "2019",
    // },
];

const education = [{
    course:"B.Tech (Electrical Engineering)",
    university:"Rajasthan technical University, Kota",
    session:"2018-2022",
    percentage:"80%",
},
// {
//     course:"B.Tech (Electrical)",
//     university:"Rajasthan Technical University",
//     session:"2018-2022",
//     percentage:"68.50%",
// },
{
    course:"12th Standard",
    university:"Rajasthan Board of Secondary Education",
    session:"2016-2017",
    percentage:"86.40%",
},
{
    course:"10th Standard",
    university:"Rajasthan Board of Secondary Education",
    session:"2014-2015",
    percentage:"76.67%",
},



];

const skills = [
    {
        name: "Javascript",
        value: 65,
    },
    {
        name: "React.js",
        value: 65,
    },
    {
        name: "Express.js",
        value: 80,
    },
    {
        name: "Node.js",
        value: 80,
    },
    {
        name: "MongoDB",
        value: 80,
    },
    {
        name: "Material Ui",
        value: 70,
    },
    {
        name: "Adobe Photoshop",
        value: 60,
    },
    {
        name: "HTML CSS",
        value: 70,
    },
    {
        name: "MySQL",
        value: 50,
    },
    
];

const services = [{
        title: "Web Developer",
        description: "Can develop innovative, user interactive web applications.",
    },
    // {
    //     title: "Mobile Apps",
    //     description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed at nisl euismod urna bibendum sollicitudin.",
    // },
    // {
    //     title: "Wordpress Design",
    //     description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed at nisl euismod urna bibendum sollicitudin.",
    // },
];

const dataportfolio = [
    {
        img: require("./e-commerce.jpg"),
        description: "E-commerce Website Using MERN(Website, Admin, Server,Payment)",
        link: "https://github.com/sumitttvvverma/E-commerce-webSite"
    },
    {
        img: require("./mern-admin-blog.png"),
        description: "MERN Blogging Website (Website, Admin, Server)",
        link: "https://github.com/sumitttvvverma/MERN_client-Server-admin",
    },
    {
        img: require("./iNoteBook.png"),
        description: "MERN iNoteBook login-signup with CRUD operation and privacy of notes",
        link: "https://github.com/sumitttvvverma/i-NoteBook-mern",
    },
    {
        img: require("./CarGame.png"),
        description: "Car Crashing Game Application (JS)",
        link: "https://github.com/sumitttvvverma/carGameUsingJS",
    },
    {
        img: require("./job-portal.png"),
        description: "Job-Portal MERN",
        link: "https://github.com/sumitttvvverma/Job-portal-app-mern",
    },
    
    
];

const contactConfig = {
    YOUR_EMAIL: "jrsumitverma@gmail.com",
    YOUR_FONE: "+91-7665889749",
    // description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi vehicula eu nunc et sollicitudin. Cras pulvinar, nisi at imperdiet pharetra. ",
    // creat an emailjs.com account 
    // check out this tutorial https://www.emailjs.com/docs/examples/reactjs/
    YOUR_SERVICE_ID: "service_kzdjsl9",
    YOUR_TEMPLATE_ID: "template_y5pwr0e",
    YOUR_PUBLIC_KEY: "Myvww2oxm4EDqDq0D",
    // YOUR_USER_ID: "user_id",
};

const socialprofils = {
    github: "https://github.com/sumitttvvverma?tab=repositories",
    // facebook: "https://facebook.com",
    linkedin: "https://www.linkedin.com/in/sumit-verma-b29b55194",
    // twitter: "https://twitter.com",
};
export {
    meta,
    dataabout,
    dataportfolio,
    worktimeline,
    education,
    skills,
    services,
    introdata,
    contactConfig,
    socialprofils,
    logotext,
};